import { createOrGetFetchedState } from '@vista-digital/utilities';
import { ocapiClient } from '../../../../api-clients/ocapi/client';
import { getCacheDuration } from '../../../../utils/get-cache-duration';
import { loadDataFromApi } from '../../../../utils/load-data-from-api';
import { browsingDomainStore } from '../../store';
import { onFilmAvailabilityListLoadSuccess } from './utils/on-success';
export const loadFilmAvailabilitiesForSite = async (siteId) => {
    const state = createOrGetFetchedState(browsingDomainStore.data.filmAvailabilitiesBySiteId, siteId);
    await loadDataFromApi({
        api: () => ocapiClient.instance.v1.browsing.availability.films.getForSite(siteId),
        state,
        cacheDuration: getCacheDuration('films'),
        onSuccess: onFilmAvailabilityListLoadSuccess,
		reloadCachedData: true // HACK - get fresh data each time, rather than relying on localstorage. Might solve https://se-ocg.atlassian.net/browse/COMS-15123
    });
};
//# sourceMappingURL=load-film-availabilities-for-site.js.map